export default __webpack_public_path__ + "static/media/select-clear.532ba311.svg";